import { Divider, Typography } from '@mui/material';
import { Box } from '@mui/system';
import PersonIcon from '@mui/icons-material/Person';

export default function DataCard({ label, data, obKey, Icon }) {
  return (
    <Box display={'flex'} gap={4}>
      <Box display={'flex'} gap={1} alignItems={'center'}>
        {Icon ? <Icon sx={{ height: 23, width: 23 }} /> : <PersonIcon sx={{ height: 23, width: 23 }} />}
        <Typography fontWeight={600} fontSize={18}>
          {label}
        </Typography>
      </Box>
      <Box flexGrow={1}>
        <Typography justifySelf={'flex-end'} pr={3}>
          {Array.isArray(data?.[obKey]) ? data?.[obKey].toString() : data?.[obKey] ?? '--'}
        </Typography>
        <Divider />
      </Box>
    </Box>
  );
}
